var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(-28 -32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 4,
    height: 4,
    transform: "translate(28 32)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 4,
    height: 4,
    transform: "translate(28 40)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 4,
    height: 4,
    transform: "translate(28 48)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 4,
    height: 4,
    transform: "translate(36 32)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 4,
    height: 4,
    transform: "translate(36 40)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 4,
    height: 4,
    transform: "translate(36 48)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 4,
    height: 4,
    transform: "translate(44 32)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 4,
    height: 4,
    transform: "translate(44 40)",
    fill: "#787c7c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 4,
    height: 4,
    transform: "translate(44 48)",
    fill: "#787c7c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarIcon);
export default __webpack_public_path__ + "static/media/navbar-icon.87c39fd03d88dc61f8b59a0e857226b3.svg";
export { ForwardRef as ReactComponent };